import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { InstallBanner } from "./components/InstallBanner";
import { ScrollToTop } from "./components/ScrollToTop";
import Home from "./pages/Home";
import SearchResults from "./pages/SearchResults";
import TruckDetail from "./pages/TruckDetail";
import Pricing from "./pages/Pricing";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Favorites from "./pages/Favorites";
import Alerts from "./pages/Alerts";
import PaymentReturn from "./pages/PaymentReturn";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Account from "./pages/Account";
import MentionsLegales from "./pages/MentionsLegales";
import CGU from "./pages/CGU";
import Confidentialite from "./pages/Confidentialite";
import Markets from "./pages/Markets";
import MarketDetail from "./pages/MarketDetail";

const Layout = ({ children }) => (
  <div className="App flex flex-col min-h-screen">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <InstallBanner />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/recherche" element={<Layout><SearchResults /></Layout>} />
          <Route path="/marches" element={<Layout><Markets /></Layout>} />
          <Route path="/marche/:slug" element={<Layout><MarketDetail /></Layout>} />
          <Route path="/foodtruck/:slug" element={<Layout><TruckDetail /></Layout>} />
          <Route path="/tarifs" element={<Layout><Pricing /></Layout>} />
          <Route path="/favoris" element={<Layout><Favorites /></Layout>} />
          <Route path="/alertes" element={<Layout><Alerts /></Layout>} />
          <Route path="/connexion" element={<Layout><AuthPage /></Layout>} />
          <Route path="/mot-de-passe-oublie" element={<Layout><ForgotPassword /></Layout>} />
          <Route path="/reinitialiser-mot-de-passe" element={<Layout><ResetPassword /></Layout>} />
          <Route path="/compte" element={<Layout><Account /></Layout>} />
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
          <Route path="/admin" element={<Layout><Admin /></Layout>} />
          <Route path="/payment/success" element={<Layout><PaymentReturn /></Layout>} />
          <Route path="/payment/cancel" element={<Layout><PaymentReturn cancel /></Layout>} />
          <Route path="/mentions-legales" element={<Layout><MentionsLegales /></Layout>} />
          <Route path="/cgu" element={<Layout><CGU /></Layout>} />
          <Route path="/confidentialite" element={<Layout><Confidentialite /></Layout>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
